import React, { Component } from "react";
import Button from "../../components/Button";
import { FaChevronLeft } from "react-icons/fa";
import dayjs from "dayjs";
import { DATE_VOTE_FINISHED } from "../../util/constants";

import "./styles.css";

export default class VotesClosed extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div className="PageContainer">
        <div className="VoteContainer">
          <h2 className="Votes__title">
            Votação encerrada em{" "}
            {dayjs(DATE_VOTE_FINISHED).format("DD/MM/YYYY HH:mm")}
          </h2>
          <h4 className="Votes__subtitle">
            Obrigado por participar! Acompanhe o resultado em nossas redes
            @DRAFT5gg e também no site{" "}
            <a
              href="https://draft5.gg"
              target="_blank"
              rel="noopener noreferrer"
            >
              DRAFT5.gg
            </a>
          </h4>
          <center>
            <Button
              className="Rules__GoBack"
              onClick={() => {
                this.props.history.goBack();
              }}
            >
              <FaChevronLeft size={12} />
              <span>Voltar</span>
            </Button>
          </center>
        </div>
      </div>
    );
  }
}
